/**
 * Samtykke og førstepartsmåling på v2-sidene.
 *
 * HVORFOR DEN FINNES: v2-rammen lastet bare `v2.js` og `v2-lang-scroll.js`. Marine-rammen
 * laster `marine.js`, som er nøyaktig `initTracking()` + `initConsent()` — og det var det
 * eneste stedet samtykket og målingen ble startet. Målt på publisert Stage 13.10.2026:
 * forsiden, /about, /services, /contact og /kundehistorier (alle v2-rammede) hadde INGEN
 * samtykkebanner og ingen av de to modulene, mens /products, /trygg-ai, /regelverk og
 * /innsikt (Marine-rammede) hadde begge. Live har banneret på hver side.
 *
 * Konsekvensen var at Sjurs punkt 1 ikke kunne virke: med Google Analytics «PÅ ved
 * lansering» ville ingen besøkende kunne samtykke på forsiden, så `gtag.js` ville aldri
 * blitt lastet. Og førstepartstelleren (`window.skjld.track` → POST /api/t/e) var heller
 * ikke i gang på de sidene.
 *
 * EGEN INNGANG, IKKE EN IMPORT I v2.js: Marine-rammen laster OGSÅ v2-bundelen når
 * v2-bryteren er på (se `_ramme`), så en import i `v2.js` ville kjørt `initConsent()` og
 * `initTracking()` to ganger på hver Marine-side — to bannere og doble hendelser. Denne
 * fila lastes bare av v2-rammen, og `marine.js` bare av Marine-rammen. Ingen side får begge.
 */
import { initConsent } from './consent';
import { initTracking } from './track';
// Lastes DYNAMISK, se marine.js: en statisk import gir en modulepreload på hver side.

initTracking();
initConsent();
// Påmeldingsskjemaet står på v2-sidene (artikkelbunn, /innsikt og bunnteksten), og lastes
// derfor her — samme inngang, samme grunn: Marine-rammen har sin egen.
if (document.querySelector('[data-nyhetsbrev]')) {
    import('./v2-nyhetsbrev').then((m) => m.initNyhetsbrev());
}
